import jEmployee from '@/views/user-employee/jEmployee';
import jEmployeeList from '@/views/user-employee/jEmployeeList';
import jEmployeeCreate from '@/views/user-employee/detail/jEmployeeCreate';

import auth from '@/middleware/auth';
import log from '@/middleware/log';
import admin from '@/middleware/admin';

export default [
  {
    path: '/administrator',
    name: 'jEmployee',
    component: jEmployeeList,
    meta: {
      title: 'Company User',
      middleware: [auth, admin, log],
      layout: 'jSettingWrapper',
    },
    children: [
      {
        path: '/administrator/create',
        name: 'jEmployeeCreate',
        component: jEmployeeCreate,
        meta: {
          title: 'Create User',
          middleware: [auth, admin, log],
        },
      },
    ],
  },
  {
    path: '/administrator/detail/:id',
    name: 'jEmployeeUpdate',
    component: jEmployee,
    meta: {
      title: 'Update User',
      middleware: [auth, admin, log],
      layout: 'jSettingWrapper',
    },
  },
  {
    path: '/administrator/assignment/:id',
    name: 'Assignment',
    component: jEmployee,
    meta: {
      title: 'Assignment',
      middleware: [auth, admin, log],
      layout: 'jSettingWrapper',
    },
  },
];



// WEBPACK FOOTER //
// ./src/router/jRouterUser.js